import { View } from "@amzn/stencil-react-components/layout";
import React, { FC } from "react";

const NO_IMAGE_PLACEHOLDER = "/img/no_logo_image.png";

export interface DeviceThumbnailProps {
  imageSrc: string;
  altText: string;
  /** Square edge length in px. Figma device rows use 48. */
  size?: number;
  dataTestId?: string;
}

export const DeviceThumbnail: FC<DeviceThumbnailProps> = ({
  imageSrc,
  altText,
  size = 48,
  dataTestId = "device-thumbnail",
}) => (
  <View
    width={size}
    height={size}
    flex="0 0 auto"
    border="1px solid var(--st-dt-color-neutral-20)"
    borderRadius="var(--st-dt-dimensions-border-radius-100)"
    overflow="hidden"
  >
    <img
      src={imageSrc.trim() ? imageSrc : NO_IMAGE_PLACEHOLDER}
      alt={altText}
      data-testid={dataTestId}
      style={{ width: "100%", height: "100%", objectFit: "contain" }}
    />
  </View>
);
